import { Archive } from "lucide-react";

const TEAM = [
  { name: "Young, Kim K", role: "Supervisor - App Security & Infrastructure (HRT)", initials: "KY", email: "kim.young@kochcc.com" },
  { name: "Finch, Dennis", role: "Application Security Architect", initials: "DF", email: "dennis.finch@kochcc.com" },
  { name: "Shah, Dhairya", role: "IT Product Owner", initials: "DS", email: "dhairya.shah@kochcc.com" },
  { name: "Thanneeru, Hemadri", role: "Kronos Engineer", initials: "HT", email: "hemadri.thanneeru@kochcc.com" },
  { name: "Marshall, John", role: "Technical Lead - HRT Infrastructure", initials: "JM", email: "john.marshall@kochcc.com" },
  { name: "Kalita, Rajkamal", role: "Sr. SAP Basis Administrator", initials: "RK", email: "rajkamal.kalita@kochcc.com" },
  { name: "Fatwa, Nabil", role: "HRIT Cloud Systems Analyst", initials: "NF", email: "nabil.fatwa@kochcc.com" },
  { name: "Singh, Sandhya", role: "SAP Basis Administrator", initials: "SS", email: "sandhya.singh1@kochcc.com" },
  { name: "Morrison, LaTanya R", role: "Application Security Analyst", initials: "LM", email: "latanya.morrison@kochcc.com" },
  { name: "Rajagopal, Yamini", role: "Technical Lead - Application Security", initials: "YR", email: "yamini.rajagopal@kochcc.com" },
  { name: "Barba, Cath", role: "Application Security Analyst", initials: "CB", email: "cath.barba@kochcc.com" },
  { name: "Mukherjee, Manish", role: "Application Security Analyst", initials: "MM", email: "manish.mukherjee@kochcc.com" },
  { name: "Chandru, Swathi", role: "Application Security Analyst", initials: "SC", email: "swathi.chandru@kochcc.com" },
  { name: "Naikode, Adarsh", role: "Associate - Application Security Analyst", initials: "AN", email: "adarsh.naikode@kochcc.com" },
  { name: "JALIYAL, VARSHA SHIVAYOGI", role: "Associate Application Security Analyst", initials: "JV", email: "varsha.jaliyal@kochcc.com" },
];

const HOME_LOGOS = [
  { name: "Infor", src: `${process.env.PUBLIC_URL || ""}/Logos/Infor.png`, href: "https://mingle-portal.inforcloudsuite.com/KOCHIND_PRD/" },
  { name: "SailPoint", src: `${process.env.PUBLIC_URL || ""}/Logos/Sailpoint.png`, href: "https://koch.identitynow.com/ui/d/dashboard" },
  { name: "Avature", src: `${process.env.PUBLIC_URL || ""}/Logos/Avature.png`, href: "https://koch.avature.net/#Home" },
  { name: "Tableau", src: `${process.env.PUBLIC_URL || ""}/Logos/Tableau.png`, href: "https://tableau.kochind.com/#/site/Koch-TalentAnalytics/home" },
  { name: "Visier", src: `${process.env.PUBLIC_URL || ""}/Logos/Visier.png`, href: "http://koch.visier.com/" },
];

// Map tiles to their corresponding navigation item IDs
const TILE_NAV_MAP = {
  "entitlement-lookup": "entitlement-lookup",
  "compare-access": "compare-access",
  "comparator": "comparator",
  "das-mapping": "das-mapping",
  "access-search": "access-search",
  "access-request-history": "access-request-history",
  "security-access-report": "security-access-report",
  "create-user-group": "create-user-group",
  "ap-impact": "ap-impact",
  "servicenow-actions": "servicenow-actions",
  "sprint-metrics": "sprint-metrics",
  "provisioning-errors": "provisioning-errors",
  "actor-org-unit": "actor-org-unit",
  "tenant-refresh": "tenant-refresh",
};

export default function HomePage({ onNavigate, enableDasMapping = false, enableTenantRefresh = false, isNavItemAllowed }) {
  // Helper to check if a tile should be shown
  const shouldShowTile = (navItemId) => {
    if (!isNavItemAllowed) return true; // If no access control passed, show all
    return isNavItemAllowed(navItemId);
  };

  return (
    <div className="home-root">
      <div className="home-header">
        <div className="home-header-left">
          <div className="logo-mark">H</div>
          <div>
            <div className="home-header-title">HRT Security & Infrastructure Resource Center</div>
            <div className="home-header-sub">Admin Tools · Koch</div>
          </div>
        </div>
      </div>

      <div className="home-body">
        <div className="home-main">
          <div className="home-welcome">
            <div className="home-welcome-title">Welcome to the HRT Security & Infrastructure Resource Center!</div>
            <div className="home-welcome-desc">
              This site is your go-to hub for functionalities like Access Search, Compare Access, Password Change, Request Accounts in myHR non-prod tenants and many more. It also provides you with information on viewing supported applications, submitting Compass incidents, and getting team help.
            </div>
          </div>

          <div className="home-section-title">Quick Links</div>
          <div className="home-quick-links">
            {shouldShowTile("entitlement-lookup") && (
            <div className="home-card" onClick={() => onNavigate("entitlement-lookup")}>
              <div className="home-card-img">
                <div className="home-card-img-label">Entitlement Lookup</div>
                <div className="home-card-icon">🗂️</div>
              </div>
              <div className="home-card-label">Profile → Identities</div>
            </div>
            )}

            {shouldShowTile("compare-access") && (
            <div className="home-card" onClick={() => onNavigate("compare-access")}>
              <div className="home-card-img">
                <div className="home-card-img-label">Compare Access</div>
                <div className="home-card-icon">⚖️</div>
              </div>
              <div className="home-card-label">Compare Up to 5 Employees</div>
            </div>
            )}

            {shouldShowTile("comparator") && (
            <div className="home-card" onClick={() => onNavigate("comparator")}>
              <div className="home-card-img">
                <div className="home-card-img-label">Permission Comparator</div>
                <div className="home-card-icon">🔐</div>
              </div>
              <div className="home-card-label">Compare Access</div>
            </div>
            )}

            {enableDasMapping && shouldShowTile("das-mapping") && (
              <div className="home-card" onClick={() => onNavigate("das-mapping")}>
                <div className="home-card-img">
                  <div className="home-card-img-label">Data Access Mapping</div>
                  <div className="home-card-icon">🧭</div>
                </div>
                <div className="home-card-label">Single Project Mapping</div>
              </div>
            )}

            {shouldShowTile("access-search") && (
            <div className="home-card" onClick={() => onNavigate("access-search")}>
              <div className="home-card-img">
                <div className="home-card-img-label">Access Search</div>
                <div className="home-card-icon">🔍</div>
              </div>
              <div className="home-card-label">Search Employee Access</div>
            </div>
            )}

            {shouldShowTile("access-request-history") && (
            <div className="home-card" onClick={() => onNavigate("access-request-history")}>
              <div className="home-card-img">
                <div className="home-card-img-label">Access Request History</div>
                <div className="home-card-icon">🕒</div>
              </div>
              <div className="home-card-label">Grant & Revoke History</div>
            </div>
            )}

            {shouldShowTile("security-access-report") && (
            <div className="home-card" onClick={() => onNavigate("security-access-report")}>
              <div className="home-card-img">
                <div className="home-card-img-label">Security Access Report</div>
                <div className="home-card-icon">📈</div>
              </div>
              <div className="home-card-label">myHR Security Access</div>
            </div>
            )}

            {shouldShowTile("create-user-group") && (
            <div className="home-card" onClick={() => onNavigate("create-user-group")}>
              <div className="home-card-img">
                <div className="home-card-img-label">Visier Security Manager</div>
                <div className="home-card-icon">👥</div>
              </div>
              <div className="home-card-label">Groups, Permissions & Runbook</div>
            </div>
            )}

            {shouldShowTile("ap-impact") && (
            <div className="home-card" onClick={() => onNavigate("ap-impact")}>
              <div className="home-card-img">
                <div className="home-card-img-label">Access Profile Impact</div>
                <div className="home-card-icon">🔗</div>
              </div>
              <div className="home-card-label">Roles, Siblings & Entitlements</div>
            </div>
            )}

            {shouldShowTile("servicenow-actions") && (
            <div className="home-card" onClick={() => onNavigate("servicenow-actions")}>
              <div className="home-card-img">
                <div className="home-card-img-label">ServiceNow Actions</div>
                <div className="home-card-icon">📋</div>
              </div>
              <div className="home-card-label">Manage Sprints & Stories</div>
            </div>
            )}

            {shouldShowTile("sprint-metrics") && (
            <div className="home-card" onClick={() => onNavigate("sprint-metrics")}>
              <div className="home-card-img">
                <div className="home-card-img-label">Sprint Metrics</div>
                <div className="home-card-icon">📊</div>
              </div>
              <div className="home-card-label">Team Performance & Analytics</div>
            </div>
            )}

            {shouldShowTile("provisioning-errors") && (
            <div className="home-card" onClick={() => onNavigate("provisioning-errors")}>
              <div className="home-card-img">
                <div className="home-card-img-label">Provisioning Errors</div>
                <div className="home-card-icon">⚠️</div>
              </div>
              <div className="home-card-label">Failed Provisioning Events</div>
            </div>
            )}

            {shouldShowTile("actor-org-unit") && (
            <div className="home-card" onClick={() => onNavigate("actor-org-unit")}>
              <div className="home-card-img">
                <div className="home-card-img-label">Assign Org Units</div>
                <div className="home-card-icon">🏢</div>
              </div>
              <div className="home-card-label">Assign Org Units to Actor</div>
            </div>
            )}
            {enableTenantRefresh && shouldShowTile("tenant-refresh") && (
            <div className="home-card" role="button" tabIndex={0} onClick={() => onNavigate("tenant-refresh")}
              onKeyDown={event => { if (event.key === "Enter" || event.key === " ") onNavigate("tenant-refresh"); }}>
              <div className="home-card-img"><div className="home-card-img-label">Tenant Refresh</div><div className="home-card-icon"><Archive size={34} /></div></div>
              <div className="home-card-label">AX5 Pre-refresh Backup</div>
            </div>
            )}
          </div>

          <hr className="home-divider" />

          <div className="home-meet-title">Meet the Application Security Team</div>
          <div className="home-meet-desc">
            Our team ensures the security, stability, and compliance of both IT infrastructure and applications by managing security, overseeing application vulnerability assessments, and embedding secure coding practices into development. We lead incident response for infrastructure and application security issues, maintain patching for systems and applications, and enforce security policies to ensure compliance. Additionally, our team collaborates on cloud security architecture, automates security processes, and provides consulting, fostering a robust and comprehensive security posture for reliable and available infrastructure platforms across the organization.
          </div>

          <hr className="home-divider" />

          <div className="home-apps-section">
            <div className="home-section-title">Applications We Support</div>
            <div className="home-apps-logos">
              {HOME_LOGOS.map((app) => (
                <a
                  key={app.name}
                  href={app.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="home-app-logo-tile"
                  title={app.name}
                >
                  <img className="home-app-logo-image" src={app.src} alt={app.name} />
                </a>
              ))}
            </div>
          </div>

          <hr className="home-divider" />

          <div className="home-compass-section">
            <div className="home-section-title">Request Assistance in Compass</div>
            <div className="home-compass-body">
              <div className="home-compass-left">
                <p className="home-compass-instruction">
                  <u>Once you open the form in Compass, click the heart to save it to your favorites. Then enter the following:</u>
                </p>
                <p className="home-compass-question"><u>*What product or service do you need help with?</u></p>
                <ul className="home-compass-list">
                  <li><strong>myHR Infor Security</strong> (for myHR or Maximus Security topics)</li>
                  <li><strong>myHR Talent Analytics Security</strong> (for Tableau, QuickSight, or other Data &amp; Analytics Security topics)</li>
                  <li><strong>myHR Avature Security</strong> (for Avature or other Talent Admin security topics)</li>
                  <li><strong>KBS SAP HR Security</strong> (KGS SAP Environments)</li>
                  <li><strong>myHR ServiceNow HR Security</strong> (ServiceNow HR Service Delivery)</li>
                </ul>
                <p className="home-compass-note">
                  *<u>Assignment Group</u>: Will auto-populate to <strong>KGS HRT Application Security</strong> for any of the products listed above
                </p>
              </div>
              <div className="home-compass-right">
                <a
                  href="https://kochprod.service-now.com/compass?id=sc_cat_item&table=sc_cat_item&sys_id=3499c7d9dbd91300f37f7c28bf961901"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="home-compass-btn"
                >
                  <div className="home-compass-btn-title">Report An Issue</div>
                  <div className="home-compass-btn-desc">Report an Issue on something that is broken or incorrect.</div>
                </a>
                <a
                  href="https://kochprod.service-now.com/compass?id=sc_cat_item&table=sc_cat_item&sys_id=88a964b6db991b80f37f7c28bf96199f&searchTerm=submit%20a%20request"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="home-compass-btn"
                >
                  <div className="home-compass-btn-title">Submit A Request</div>
                  <div className="home-compass-btn-desc">Use this if you are requesting/asking something from the team.</div>
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="home-sidebar">
          <div className="home-sidebar-title">Our Team:</div>
          <div className="home-team-list">
            {TEAM.map(member => (
              <div key={member.name} className="home-team-member">
                <div className="home-team-avatar">{member.initials}</div>
                <div className="home-team-info">
                  {member.email
                    ? <a href={`mailto:${member.email}`} className="home-team-name">{member.name}</a>
                    : <div className="home-team-name">{member.name}</div>}
                  <div className="home-team-role">{member.role}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
